import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { CardWidget, ViewCard } from 'apps/dashboard/card/scripts/components';
import {
  Content,
  Layout,
  Stack,
} from 'apps/dashboard/shared/scripts/components';
import { PRO_MODE_ENABLED } from 'apps/shared/scripts/feature-gating/constants';
import useFeatureGate from 'apps/shared/scripts/feature-gating/hooks';
import { useInvoiceById } from 'apps/shared/scripts/graphql';
import { useOnError } from 'apps/shared/scripts/hooks';

import { InvoiceDetails, LoadingInvoice } from '../../components';

import messages from './messages.json';

const InvoiceContainer = () => {
  const { invoiceId } = useParams();
  const { onError } = useOnError();
  const { invoice, isLoading: isLoadingInvoice } = useInvoiceById({
    variables: { id: invoiceId! },
    onError,
  });

  const isProModeEnabled = useFeatureGate(PRO_MODE_ENABLED);

  return (
    <Layout>
      <Content
        backTo="/dashboard/billing"
        title={messages.invoiceTitle}
        rightHeader={invoice && <ViewCard cardId={invoice.cardId} />}
      >
        {isProModeEnabled && (
          <Row>
            <Col md={7}>
              <Stack minimal>
                {isLoadingInvoice || !invoice ? (
                  <LoadingInvoice />
                ) : (
                  <InvoiceDetails {...invoice} />
                )}
              </Stack>
            </Col>
            <Col md={5}>
              <Stack>
                {isLoadingInvoice || !invoice ? (
                  <LoadingInvoice />
                ) : (
                  <CardWidget id={invoice.cardId} />
                )}
              </Stack>
            </Col>
          </Row>
        )}
      </Content>
    </Layout>
  );
};

InvoiceContainer.displayName = 'InvoiceContainer';

export default InvoiceContainer;
